import {Inject, Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, switchMap} from 'rxjs/operators';
import {StreamTranscodingConfiguration, StreamTranscodingConfigurationsService} from '../../services/api/stream-transcoding-configurations';
import * as ActionsSet from './stream-transcoding-configurations.actions';

@Injectable()
export class StreamTranscodingConfigurationsEffects {
  // noinspection JSUnusedGlobalSymbols
  public loadAll$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsSet.loadStreamTranscodingConfigurations),
    switchMap(() => this.service.getAll().pipe(
      map((items: StreamTranscodingConfiguration[]) =>
        ActionsSet.loadStreamTranscodingConfigurationsSuccess({items})
      ),
      catchError((error) => of(ActionsSet.loadStreamTranscodingConfigurationsFailure({error: this.extractErrorMessage(error)})))
    ))
  ));
  // noinspection JSUnusedGlobalSymbols
  public create$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsSet.createStreamTranscodingConfiguration),
    switchMap(({dto}) => this.service.create(dto).pipe(
      map((item: StreamTranscodingConfiguration) =>
        ActionsSet.createStreamTranscodingConfigurationSuccess({item})
      ),
      catchError((error) => of(ActionsSet.createStreamTranscodingConfigurationFailure({error: this.extractErrorMessage(error)})))
    ))
  ));
  // noinspection JSUnusedGlobalSymbols
  public delete$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsSet.deleteStreamTranscodingConfiguration),
    switchMap(({id}) => this.service.delete(id).pipe(
      map(() => ActionsSet.deleteStreamTranscodingConfigurationSuccess({id})),
      catchError((error) => of(ActionsSet.deleteStreamTranscodingConfigurationFailure({id, error: this.extractErrorMessage(error)})))
    ))
  ));
  // noinspection JSUnusedGlobalSymbols
  public resume$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsSet.resumeStreamTranscodingConfiguration),
    switchMap(({id}) => this.service.resume(id).pipe(
      map((item: StreamTranscodingConfiguration) =>
        ActionsSet.resumeStreamTranscodingConfigurationSuccess({item})
      ),
      catchError((error) => of(ActionsSet.resumeStreamTranscodingConfigurationFailure({id, error: this.extractErrorMessage(error)})))
    ))
  ));
  // noinspection JSUnusedGlobalSymbols
  public stop$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsSet.stopStreamTranscodingConfiguration),
    switchMap(({id}) => this.service.stop(id).pipe(
      map((item: StreamTranscodingConfiguration) =>
        ActionsSet.stopStreamTranscodingConfigurationSuccess({item})
      ),
      catchError((error) => of(ActionsSet.stopStreamTranscodingConfigurationFailure({id, error: this.extractErrorMessage(error)})))
    ))
  ));

  constructor(
    private readonly actions$: Actions,
    @Inject(StreamTranscodingConfigurationsService) private readonly service: StreamTranscodingConfigurationsService
  ) {
  }

  private extractErrorMessage(error: any): string {
    if (typeof error === 'string') {
      return error;
    }
    if (error?.error?.message) {
      return error.error.message;
    }
    if (error?.message) {
      return error.message;
    }
    if (error?.statusText) {
      return error.statusText;
    }
    return 'An unknown error occurred';
  }
}
